import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA0F-Nk4frZQqoMMKRf-l5dOnub0HyS-gU",
  authDomain: "timeline-9efe2.firebaseapp.com",
  projectId: "timeline-9efe2",
  storageBucket: "timeline-9efe2.firebasestorage.app",
  messagingSenderId: "480528428197",
  appId: "1:480528428197:web:f6300bf60a5940b76af14c",
  measurementId: "G-4P2Y4GXHPQ"
  };
  

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app,'production');